import { Grid, makeStyles, Theme, Typography } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import { hexToRGB, Location } from '@tuqqi/common'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LocationInput } from './LocationInput'

interface Props {
    shown?: boolean
    setShown?: React.Dispatch<React.SetStateAction<boolean>>
    label: string
    value: Location | null
    isCustomField?: boolean
    sourceField: string
    isNewItem?: boolean
    description?: string | null
    onBlur?(value?: string): void
    icon: ReactNode
    isRtl: boolean
}

const styles = (theme: Theme) => ({
    descriptionField: {
        paddingTop: 10,
        fontSize: 14
    },
    btn: {
        cursor: 'pointer',
        width: 'fit-content',
        paddingRight: 12,
        paddingLeft: 12,
        borderRadius: 4,
        height: 30,
        border: `1px solid #3f51b5`,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent',
        '&:hover': {
            background: hexToRGB("#3f51b5", 0.16),
        }
    } as CSSProperties,
    btnText: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: 0.5,
        color: '#3f51b5'
    },
    label: {        
        // color: '#989AA9',
        color: '#6e707d',
        marginBottom: 4
    },
    inputContainer: {
        width: '100%',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: 6
    },
    inputContainerCustom: {
        width: '100%',
        paddingTop: 6
    },
    iconContainer: {
        color: 'black',
        paddingRight: theme.spacing(3),
        paddingTop: 35
    },
    description: {
        marginTop: theme.spacing(0.5)
    },
    inputWrap: {
        width: '100%',
        background: 'transparent',
        //borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        borderBottom: `1px solid black`,
    } as CSSProperties,
    singleLine: {
        height: 30,
        alignItems: 'center',
    },
    multiLine: {
        paddingTop: 5,
        paddingBottom: 5,
        alignItems: 'flex-end',
    },
    activeInput: {
        borderBottom: `1px solid ${"#3f51b5"}`,
        // boxShadow: `0px 0px 4px ${hexToRGB("#3f51b5", 0.16)}`
    },
    labelError: {
        color: "#ff4848",
    },
    labelWrap: {
        display: 'flex'
    }
})

const useStyles = makeStyles(styles)
const space = <span>&nbsp;</span>

export const LocationTextEdit = (props: Props) => {
    const { shown, setShown, label, value, description, onBlur, icon, sourceField, isNewItem, isCustomField } = props
    const [t] = useTranslation("i18_item")

    const classes = useStyles()
    const error = ''
    const required = false
  
    const Input = <div data-intrcm-id="LocationTextEdit_ruhj0zak" className={`${sourceField}`}>
        <LocationInput isNewItem={isNewItem} locationAddress={value} onBlur={onBlur} />
    </div>


    const show = () => {
        if(!isNewItem) return
        setShown?.(true)
    }

    const Input1 = <div data-intrcm-id="LocationTextEdit_fexjw7gj" className={`${classes.btn}`} onClick={show}>
        <div data-intrcm-id="LocationTextEdit_9kxpzoga" className={classes.btnText}>{`${t("Add")} ${label}`}</div>
    </div>

    return <Grid container direction='row' wrap='nowrap'>
            {icon && <Grid item className={classes.iconContainer} data-testid='icon-container'>
                {icon}
            </Grid>}
            <Grid container direction='column' item className={`${isCustomField ? classes.inputContainerCustom : classes.inputContainer}`}>
                <Grid className={classes.labelWrap} item>
                    <Typography variant="body2" className={`${classes.label} ${!!error ? classes.labelError : ''}`} >{label}</Typography>
                    {error && <Typography variant="body2" className={`${classes.label} ${classes.labelError}`} > {space}{error}</Typography>}
                    <Typography variant="body2" className={`${classes.label} ${!!error ? classes.labelError : ''}`} >{required ? ' *' : ''}</Typography>
                </Grid>
                <Grid item>
                    {isNewItem && !shown ? Input1 : Input}
                </Grid>
                {!!description && <span
             style={{ 
                direction: props.isRtl ? 'rtl' : 'ltr',
                textAlign: props.isRtl ? 'right' : 'left' 
            }} 
             className={classes.descriptionField}>
                 {description}
             </span>}
            </Grid> 
        </Grid>
}